<template>
    <div>
        <div v-if="$route.query.batchId && $route.query.tab === 'batch'" class="QCBatchDetail">
            <QCBatchDetail @goToStartWork="goToStartWork"></QCBatchDetail>
        </div>
        <div v-else class="QCBatchList">
            <!--table list qc campaign-->
            <v-container fluid class="fci-scrollbar content-tab">
                <div class="display-flex align-center justify-space-between mb-10">
                    <div style="width: 380px;">
                        <SearchQCBatch
                            :qc-campaign-id="qcCampaign.id"
                            @input="searchNow($event)"
                            @campaign-selected="viewQCCampaign($event)"
                            class="search-custom">
                        </SearchQCBatch>
                    </div>
                    <v-layout align-center justify-end class="mx-0 my-0"
                              v-if="canEditQCCampaign(permission)">
                        <div class="btn-export btn-primary mr-6" @click="openQCCampaignExport">
                            {{ $f.tc('download') }} {{ $f.tc('report') }}
                        </div>
                        <div class="btn-primary" @click="addQCBatch">
                            <img src="/img/add.svg" alt="icon-add" style="transform: scale(1.2); margin-right: 8px">
                            {{ $f.tc('add') + ' ' + $t('batch') }}
                        </div>
                    </v-layout>
                </div>
                <DataTableCustom
                    :headers="headers"
                    :items="items"
                    :current-page="pagination.page"
                    :total-page="totalPage"
                    :items-per-page="pagination.rowsPerPage"
                    :total-items="totalItems"
                    :sort-by="sortBy"
                    :sort-direction="sortDirection"
                    @sort-change="refresh($event)"
                    @page-change="refresh"
                    @item-per-page-change="updateItemsPerPage"
                    @row-click="viewQCCampaign($event)"
                    style="position: relative"
                >
                    <template v-slot:assign_to="props">
                        {{ $utils.limitStringLength(props.item['assign_to'].join(', '), 50) }}
                    </template>
                    <template v-slot:action="props">
                        <span class="row-actions">
                            <v-btn icon small class="mx-0" v-if="canEditQCCampaign(qcCampaign.permission)"
                                   @click.stop="copyItem(props.item)">
                                <img src="/img/copy-1_grey.svg" alt="icon-copy">
                            </v-btn>
                            <v-btn icon small class="mx-0" v-if="canEditQCCampaign(qcCampaign.permission)"
                                   @click.stop="deleteItem(props.item)">
                                <img src="/img/delete-new.svg" alt="icon-delete">
                            </v-btn>
                        </span>
                    </template>
                </DataTableCustom>
            </v-container>
            <QCPermissionEditor ref="QCPermissionEditor"></QCPermissionEditor>
            <QCBatchCreator ref="QCBatchCreator" @reloadBatchList="refresh(1)"></QCBatchCreator>
            <QCCampaignExport ref="QCCampaignExport"></QCCampaignExport>
        </div>
    </div>
</template>
<script>
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import QCPermissionEditor from '@/views/QualityControl/Dialog/QCPermissionEditor'
import QcCampaignService from '@/services/qc.campaign.service'
import QCBatchCreator from '@/views/QualityControl/Dialog/QCBatchCreator'
import { mapState } from 'vuex'
import QCBatchDetail from '@/views/QualityControl/QCBatchDetail'
import DataTableCustom from '@/components/DataTableCustom'
import SearchQCBatch from '@/views/QualityControl/SearchQCBatch'
import QCCampaignExport from '@/views/QualityControl/Dialog/QCCampaignExport'
import lodash from 'lodash'

export default {
    name: 'QCBatchList',
    mixins: [RoleMixin],
    components: {
        QCBatchDetail,
        QCBatchCreator,
        QCPermissionEditor,
        SearchQCBatch,
        DataTableCustom,
        QCCampaignExport,
    },
    data () {
        return {
            campaignList: [],
            permissionList: this.$const.QCCampaign.permissionList,
            search: '',
            items: [],
            pagination: {
                page: 1,
                rowsPerPage: 10,
            },
            totalItems: 0,
            totalPage: 1,
            sortBy: 'name',
            sortDirection: 'asc',
            currentSort: '',
        }
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
            permission: state => state.qccampaign.campaign.permission
        }),
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('name'),
                    value: 'name',
                    sortable: true
                },
                {
                    text: this.$t('status'),
                    value: 'status',
                    sortable: true
                },
                {
                    text: this.$t('createdTime'),
                    value: 'created_time',
                    type: 'datetime',
                    sortable: true
                },
                {
                    text: this.$t('totalCalls'),
                    value: 'total_calls',
                },
                {
                    text: this.$t('pendingCalls'),
                    value: 'pending_calls',
                },
                {
                    text: this.$t('assignee'),
                    value: 'assign_to',
                    type: 'custom'
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom'
                }
            ])
        }
    },
    mounted () {
        this.refresh()
    },
    methods: {
        updateItemsPerPage (newValue) {
            this.pagination.rowsPerPage = newValue
            this.refresh()
        },
        refresh (pager) {
            this.pagination.page = isNaN(pager) ? this.pagination.page : pager

            if (pager && pager.direction) {
                this.currentSort = pager.direction === 'desc' ? pager.value : '-' + pager.value
            }
            this.$appService.showLoading()
            let qcCampaignId = this.qcCampaign ? this.qcCampaign.id : this.$route.params.QCCampaignId
            QcCampaignService.getQCBatch(
                qcCampaignId,
                this.pagination.rowsPerPage,
                this.pagination.page,
                this.currentSort,
                this.search
            ).then(
                result => {
                    this.items = []
                    this.totalItems = result.data.count
                    this.totalPage = Math.ceil(this.totalItems / this.pagination.rowsPerPage)
                    this.currentSort = result.data['ordering']
                    if (this.currentSort.indexOf('-') > -1) {
                        this.sortDirection = 'desc'
                    } else {
                        this.sortDirection = 'asc'
                    }
                    this.sortBy = result.data['ordering'].replace(/-/g, '')
                    this.items = result.data.data
                }
            ).finally(this.$appService.hideLoading)
        },
        searchNow (keyword) {
            this.search = keyword
            this.refresh(1)
        },
        deleteItem (item) {
            this.$appService.confirm(this.$t('confirmDelete', { item: item.title })).then(
                () => {
                    const i18n = {
                        action: this.$t('delete'),
                        item: this.$t('batch')
                    }
                    let qcCampaignId = this.qcCampaign ? this.qcCampaign.id : this.$route.params.QCCampaignId
                    QcCampaignService.CallListService.delete(qcCampaignId, item.id).then(
                        () => {
                            this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                            this.refresh()
                        }
                    )
                }
            )
        },
        copyItem (item) {
            this.$refs.QCBatchCreator.open(item)
        },
        viewQCCampaign (batch) {
            this.$router.push({
                path: `/qc-campaign/${this.$route.params.QCCampaignId}/`,
                query: {
                    tab: this.$route.query.tab,
                    batchId: batch.id
                }
            })
        },
        addQCBatch () {
            this.$refs.QCBatchCreator.open()
        },
        goToStartWork (data) {
            this.$emit('goToStartWork', data)
        },
        openQCCampaignExport () {
            this.$refs.QCCampaignExport.open()
        },
    },
    watch: {
        '$route.query': {
            deep: true,
            handler: function (query) {
                this.refresh(1)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 20px;
    flex-wrap: wrap;
    height: 63px;
}

.page-title {
    color: #12274F;
    font-size: 22px;
    font-weight: 700;
    flex: 1 !important;
    padding: 10px 0;
}

.content-tab {
    padding: 10px !important;
    max-height: calc(100vh - 194px);
    overflow-y: auto;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            margin-bottom: 4px !important;
        }
    }
}

.search-custom {
    ::v-deep {
        .v-input__slot {
            height: 36px;
            border-radius: 0 !important;
        }

        .v-input input {
            max-height: 36px;
            line-height: 21px !important;
        }
    }
}

.title-chart {
    line-height: 30px;
    height: 30px;
    font-size: 16px;
    font-weight: 700;
}

::v-deep {
    .v-menu {
        display: none !important;
    }

    .v-input__slot {
        background: #FFFFFF;
        padding: 0 10px !important;
        border-radius: 5px !important;
        border: 1px solid #DADFEC;
        font-size: 14px !important;
        height: 30px;
    }

    .v-input__slot:after {
        border: none !important;
    }

    .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: none !important;
    }

    .v-input.v-text-field .v-label--active {
        background: #FFFFFF !important;
        top: 8px !important;
        left: -3px !important;
        padding: 0 4px;
        color: #617CA5 !important;
        font-size: 11px !important;
    }

    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field .v-input__append-inner {
        margin-top: 4px !important;
    }

    .pager-wrap {
        border-top: 1px solid #DADFEC !important;
    }

    .v-datatable__progress {
        display: none;
    }

    .icon-search {
        right: 10px !important;
        top: 10px !important;
    }

    table.v-table thead th {
        color: #000;
    }
}
</style>
